import { Pipe, PipeTransform } from '@angular/core';
import { AddressUtils } from '../utils/address-utils';

@Pipe({
  name: 'formatAddress',
})
export class FormatAddressPipe implements PipeTransform {
  transform(address: any, prefix?: string): string {
    return AddressUtils.formatInline(address, prefix);
  }
}
